<template>
    <div class="card card-default filters">
        <div class="card-header">
            <i class="fa fa-filter" aria-hidden="true"></i> {{ $t('statistic.filters') }}
            <div class="card-actions">
                <CopyButton :disabled="isLoading"></CopyButton>
            </div>
        </div>
        <div class="card-block">
            <div class="row">
                <div class="col-md-3" v-if="scope.dateFilter">
                    <DateFilter :disabled="isLoading"></DateFilter>
                </div>
                <div class="col-md-3" v-if="scope.dateFilterSecond">
                    <DateFilterSecond :disabled="isLoading"></DateFilterSecond>
                </div>
                <div class="col-md-3" v-if="scope.dateFilterCreated">
                    <DateCreated :disabled="isLoading"></DateCreated>
                </div>
                <div class="col-md-3" v-if="scope.dateFilterReceipt">
                    <DateReceipt :disabled="isLoading"></DateReceipt>
                </div>
                <div class="col-md-3" v-if="scope.monthFilter">
                    <MonthFilter :disabled="isLoading"></MonthFilter>
                </div>
                <div class="col-md-3" v-if="scope.offerFilter">
                    <OfferFilter :disabled="isLoading"></OfferFilter>
                </div>
                <div class="col-md-3" v-if="scope.operatorFilter">
                    <OperatorFilter :disabled="isLoading"></OperatorFilter>
                </div>
                <div class="col-md-3" v-if="scope.courierFilter">
                    <CourierFilter :disabled="isLoading"></CourierFilter>
                </div>
                <div class="col-md-3" v-if="scope.monthFromFilter">
                    <MonthFromFilter :disabled="isLoading"></MonthFromFilter>
                </div>
                <div class="col-md-3" v-if="!scope.countryFilter">
                    <CountryFilter :disabled="isLoading"></CountryFilter>
                </div>
              <div class="col-md-3" v-if="scope.oneCountryFilter">
                <OneCountryFilter :disabled="isLoading"></OneCountryFilter>
              </div>
                <div class="col-md-3" v-if="scope.byWmFilter">
                    <ByWmFilter :disabled="isLoading"></ByWmFilter>
                </div>
                <div class="col-md-3" v-if="scope.byManualFilter">
                    <ByManualFilter :disabled="isLoading"></ByManualFilter>
                </div>
                <div class="col-md-3" v-if="scope.byWmFilterAll">
                    <ByWmFilterAll :disabled="isLoading"></ByWmFilterAll>
                </div>
                <div class="col-md-3" v-if="scope.oldWmFilter">
                    <OldWmFilter :disabled="isLoading"></OldWmFilter>
                </div>
                <div class="col-md-3" v-if="scope.newWmFilter">
                    <NewWmFilter :disabled="isLoading"></NewWmFilter>
                </div>
                <div class="col-md-3" v-if="scope.webmasterFilter">
                    <WebmasterFilter :disabled="isLoading"></WebmasterFilter>
                </div>
                <div class="col-md-3" v-if="scope.filterWebCountry">
                    <CountryFilter :disabled="isLoading"></CountryFilter>
                    <ByManualFilter :disabled="isLoading"></ByManualFilter>
                </div>
              <div class="col-md-3" v-if="scope.byWebmasterFilter">
                <byWebmasterFilter :disabled="isLoading"></byWebmasterFilter>
              </div>
                <div class="col-md-12 apply-buttons">
                    <button class="btn btn-primary btn-lg"
                            @click="load()"
                            :disabled="isLoading">
                        <i class="fa fa-search"></i> {{ $t('filters.apply') }}
                    </button>
                    <button class="btn btn-danger btn-lg"
                            @click="resetAll"
                            :disabled="isLoading">
                        <i class="fa fa-times"></i>
                    </button>
                    <div class="col-md-2 new_filter" v-if="scope.WorkShifts">
                        <WorkShifts :disabled="isLoading"></WorkShifts>
                    </div>
                  <div class="col-md-2 new_filter" v-if="scope.ParsePeriod">
                      <ParsePeriod :disabled="isLoading"></ParsePeriod>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import DateFilter from '../components/filters/DateFilter.vue'
  import DateFilterSecond from '../components/filters/DateFilterSecond.vue'
  import MonthFromFilter from '../components/filters/MonthFromFilter'
  import DateReceipt from '../components/filters/DateReceipt.vue'
  import MonthFilter from '../components/filters/MonthFilter.vue'
  import CountryFilter from '../components/filters/CountryFilter.vue'
  import OfferFilter from '../components/filters/OfferFilter.vue'
  import OperatorFilter from '../components/filters/OperatorFilter.vue'
  import CopyButton from '../components/filters/CopyButton.vue'
  import CourierFilter from '../components/filters/CourierFilter.vue'
  import ByWmFilter from '../components/filters/ByWmFilter.vue'
  import WebmasterFilter from '../components/filters/WebmasterFilter.vue'
  import OldWmFilter from '../components/filters/OldWmFilter.vue'
  import NewWmFilter from '../components/filters/NewWmFilter.vue'
  import ByManualFilter from '../components/filters/ByManualFilter.vue'
  import ByWmFilterAll from '../components/filters/ByWmFilterAll.vue'
  import DateCreated from '../components/filters/DateCreated.vue'
  import cSwitch from '../components/Switch'
  import WorkShifts from './filters/WorkShifts'
  import OneCountryFilter from './filters/OneCountryFilter'
  import ParsePeriod from './filters/ParsePeriod'
  import ByWebmasterFilter from './filters/ByWebmasterFilter'

export default {
    props: {
      scope: {
        type: Object,
        required: false
      }
    },
    data () {
      return {
        isLoading: false,
        isMounted: false,
        checked: false
      }
    },
    name: 'Filters',
    components: {
      OneCountryFilter,
      WorkShifts,
      ParsePeriod,
      cSwitch,
      DateReceipt,
      DateFilter,
      DateFilterSecond,
      MonthFilter,
      CountryFilter,
      OfferFilter,
      OperatorFilter,
      CopyButton,
      CourierFilter,
      ByWmFilter,
      WebmasterFilter,
      OldWmFilter,
      NewWmFilter,
      ByManualFilter,
      DateCreated,
      ByWmFilterAll,
      MonthFromFilter,
      ByWebmasterFilter
    },
    mounted () {
      this.$root.$on('data_loading', () => {
        this.isLoading = true
      })
      this.$root.$on('data_loaded', () => {
        this.isLoading = false
      })
      this.$root.$on('filters_load_new_data', () => {
        this.checked = false
      })
    },
    methods: {
      filterSwitch () {
        this.$root.$emit('filter_switch', this.checked)
      },
      resetAll () {
        this.$root.$emit('filters_reset_all')
      },
      load () {
        this.$root.$emit('filters_load_new_data')
      }
    },
    beforeDestroy () {
      this.$root.$off('filters_load_new_data')
    }
  }
</script>
<style scoped>
    .new_filter {
        position: absolute;
        right: 260px;
        top: -2px;
    }
</style>



// WEBPACK FOOTER //
// Filters.vue?e54254f2